<template>
  <div class="activity-page">
    <div class="content">
      <!-- 状态栏装饰 -->
      <div class="status-bar">
        <img src="/act-images/Layer_1.png" alt="status" class="status-img" />
      </div>

      <!-- 顶部区域：Logo + 标题 -->
      <div class="header-section">
        <div class="logo-wrapper">
          <img src="/act-images/Group9.png" alt="logo" class="logo-img" />
          <img src="/act-images/Group8.png" alt="logo text" class="logo-text" />
        </div>
        <div class="title-wrapper">
          <h1 class="main-title-en">A BIT FURTHER</h1>
          <h2 class="main-title-cn">广州站</h2>
        </div>
      </div>

      <!-- 七喜小子插图 -->
      <div class="fido-illustration">
        <img src="/act-images/Group7.png" alt="decoration" class="deco-line" />
        <div class="fido-character">
          <img src="/act-images/Group6.png" alt="Fido Dido" class="fido-main" />
          <img src="/act-images/Vector16.png" alt="deco" class="fido-deco-1" />
          <img src="/act-images/Vector15.png" alt="deco" class="fido-deco-2" />
          <img src="/act-images/Vector14.png" alt="deco" class="fido-deco-3" />
          <img src="/act-images/Vector13.png" alt="deco" class="fido-deco-4" />
          <img src="/act-images/Vector12.png" alt="deco" class="fido-deco-5" />
          <img src="/act-images/Vector11.png" alt="deco" class="fido-deco-6" />
          <img src="/act-images/Vector10.png" alt="deco" class="fido-deco-7" />
          <img src="/act-images/Vector9.png" alt="deco" class="fido-deco-8" />
          <img src="/act-images/Vector8.png" alt="deco" class="fido-deco-9" />
          <img src="/act-images/Vector7.png" alt="deco" class="fido-deco-10" />
          <img src="/act-images/Vector6.png" alt="deco" class="fido-deco-11" />
          <img src="/act-images/Vector5.png" alt="deco" class="fido-deco-12" />
          <img src="/act-images/Vector4.png" alt="deco" class="fido-deco-13" />
          <img src="/act-images/Group5.png" alt="deco" class="fido-deco-14" />
          <img src="/act-images/Vector3.png" alt="deco" class="fido-deco-15" />
        </div>
      </div>

      <!-- 活动内容标签 -->
      <div class="activity-label">
        <span>活动内容</span>
      </div>

      <!-- 活动说明文字 -->
      <div class="activity-description">
        <h3 class="desc-title">关注领好礼</h3>
        <p class="desc-subtitle">广州，我哋嚟啦！</p>
        <p class="desc-content">
          K11会员首次参与星碳计划回收，并关注广州K11和星碳计划官方微信公众号，即可领取<span class="highlight">FIDO DIDO限量版贴纸</span>。
        </p>
      </div>

      <!-- 任务进度 -->
      <div class="task-progress">
        <span class="progress-text">已完成 </span>
        <span class="progress-count">{{ followedCount }}/2 </span>
        <span class="progress-text">个</span>
        <span class="progress-text-cn">关注任务</span>
      </div>

      <!-- 关注提示 -->
      <p class="follow-hint">点击下方按钮快捷关注</p>

      <!-- 关注任务卡片 -->
      <div class="task-cards">
        <!-- 星碳计划 -->
        <div class="task-card" :class="{ 'completed': followedAccount1 }">
          <div class="card-bg"></div>
          <div class="task-number">
            <img src="/act-images/Ellipse10.png" alt="number" class="number-bg" />
            <span class="number-text">1</span>
          </div>
          <div class="task-info">
            <h4 class="task-name">星碳计划</h4>
            <p class="task-subname">XcoPack Recycling</p>
            <p class="task-desc">随时随地了解更多环保新资讯</p>
          </div>
          <button 
            v-if="!followedAccount1" 
            class="follow-btn follow-btn-red"
            @click="followAccount(1)"
          >
            点击关注
          </button>
          <div v-else class="followed-badge followed-badge-blue">
            <span>已关注</span>
          </div>
        </div>

        <!-- 分隔线 -->
        <div class="card-divider">
          <img src="/act-images/Line1.png" alt="divider" class="divider-img" />
        </div>

        <!-- 广州K11 -->
        <div class="task-card" :class="{ 'completed': followedAccount2 }">
          <div class="card-bg"></div>
          <div class="task-number">
            <img src="/act-images/Ellipse1.png" alt="number" class="number-bg" />
            <span class="number-text">2</span>
          </div>
          <div class="task-info">
            <h4 class="task-name">广州K11</h4>
            <p class="task-subname">K11 Art Mall</p>
            <p class="task-desc">解锁更多优惠活动</p>
          </div>
          <button 
            v-if="!followedAccount2" 
            class="follow-btn follow-btn-red"
            @click="followAccount(2)"
          >
            点击关注
          </button>
          <div v-else class="followed-badge followed-badge-red">
            <span>已关注</span>
          </div>
        </div>
      </div>

      <!-- 进度条 -->
      <div class="progress-bar-container">
        <div class="progress-bg">
          <div class="progress-fill" :style="{ width: followedCount * 50 + '%' }"></div>
        </div>
        <div class="progress-icons">
          <img src="/act-images/Ellipse3.png" alt="start" class="progress-start" />
          <img src="/act-images/Ellipse2.png" alt="end" class="progress-end" />
        </div>
      </div>

      <!-- 底部装饰图 -->
      <div class="bottom-decoration">
        <img src="/act-images/Group2.png" alt="background" class="deco-bg" />
        <div class="sticker-container">
          <img src="/act-images/Vector2.png" alt="sticker" class="sticker-img" />
          <img src="/act-images/Group1.png" alt="sticker" class="sticker-main" />
          <img src="/act-images/Group0.png" alt="sticker" class="sticker-text" />
          <img src="/act-images/Group.png" alt="sticker" class="sticker-icon" />
          <img src="/act-images/Vector1.png" alt="deco" class="sticker-deco-1" />
          <img src="/act-images/Vector0.png" alt="deco" class="sticker-deco-2" />
          <img src="/act-images/Vector.png" alt="deco" class="sticker-deco-3" />
        </div>
      </div>

      <!-- 品牌好友区域 -->
      <div class="brand-section">
        <p class="brand-title">品牌好友</p>
        <div class="brand-logos">
          <div class="brand-logo-small">
            <img src="/act-images/c479657d426059f5bf669f5b16af2ae741d735e6.png" alt="Fido Dido" />
          </div>
          <div class="brand-logo-large">
            <img src="/act-images/Group4.png" alt="Fido Dido" />
            <img src="/act-images/Group3.png" alt="Fido Dido" class="logo-deco" />
          </div>
        </div>
      </div>
    </div>

    <!-- 关注公众号弹窗 -->
    <div class="modal-overlay" v-if="showFollowDialog" @click.self="closeFollowDialog">
      <div class="modal-content">
        <p v-if="currentFollowAccount === 1">请长按二维码关注【星碳计划XcoPack Recycling】</p>
        <p v-else>请长按二维码关注【广州K11】</p>
        <div class="qr-image-wrapper">
          <img :src="qrImageUrl" :alt="qrImageAlt" class="qr-image" />
        </div>
        <p class="follow-tip">若已完成关注请点击确认</p>
        <div class="modal-actions">
          <button class="modal-btn cancel" @click="closeFollowDialog">取消</button>
          <button class="modal-btn confirm" @click="confirmFollow">确认</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { showSuccessToast, showFailToast } from '@/utils/request'
import { getQrcodeByPhone, updateFollowStatus } from '@/api/user'
import QRCode from 'qrcode'

export default {
  name: 'ActivityPage',
  setup() {
    const router = useRouter()
    
    const followedAccount1 = ref(false)
    const followedAccount2 = ref(false)
    const showFollowDialog = ref(false)
    const currentFollowAccount = ref(0)
    const checkinQrDataUrl = ref('')
    const userPhone = ref('')

    const followedCount = computed(() => {
      return (followedAccount1.value ? 1 : 0) + (followedAccount2.value ? 1 : 0)
    })

    const activity1Completed = computed(() => {
      return followedAccount1.value && followedAccount2.value
    })

    onMounted(() => {
      // 检查是否已登录
      const storedPhone = localStorage.getItem('userPhone')
      if (!storedPhone) {
        // 未登录，跳转到登录页面
        router.push('/login')
        return
      }
      
      userPhone.value = storedPhone
      
      // 检查用户是否已核销（checkinStatus === 1）
      const checkinStatus = localStorage.getItem('checkinStatus')
      if (checkinStatus === '1') {
        // 已核销，直接跳转到核销码页面
        router.push('/checkin')
        return
      }
      
      // 检查关注状态（从后端返回的数字 1 表示已关注）
      followedAccount1.value = localStorage.getItem('followedAccount1') === '1'
      followedAccount2.value = localStorage.getItem('followedAccount2') === '1'
      
      // 如果任务已完成，跳转到核销码页面
      if (activity1Completed.value) {
        router.push('/checkin')
      }
    })

    const followAccount = (accountNum) => {
      currentFollowAccount.value = accountNum
      showFollowDialog.value = true
    }

    const closeFollowDialog = () => {
      showFollowDialog.value = false
    }

    const confirmFollow = async () => {
      try {
        // 调用后端API更新关注状态
        const res = await updateFollowStatus(userPhone.value, currentFollowAccount.value)
        if (res.code === 200) {
          if (currentFollowAccount.value === 1) {
            followedAccount1.value = true
            localStorage.setItem('followedAccount1', '1')
          } else if (currentFollowAccount.value === 2) {
            followedAccount2.value = true
            localStorage.setItem('followedAccount2', '1')
          }
          showSuccessToast('关注成功')
          closeFollowDialog()
          
          // 如果两个都关注了，跳转到核销码页面
          if (activity1Completed.value) {
            router.push('/checkin')
          }
        } else {
          showFailToast(res.message || '关注失败')
        }
      } catch (error) {
        console.error(error)
        showFailToast('关注失败')
      }
    }

    const qrImageUrl = computed(() => {
      if (currentFollowAccount.value === 1) {
        return `/wechatQrcode/1.jpg?t=${Date.now()}`
      } else {
        return `/wechatQrcode/2.jpg?t=${Date.now()}`
      }
    })

    const qrImageAlt = computed(() => {
      return currentFollowAccount.value === 1 
        ? "星碳计划 XcoPack Recycling" 
        : "广州K11"
    })

    return {
      followedAccount1,
      followedAccount2,
      followedCount,
      activity1Completed,
      showFollowDialog,
      currentFollowAccount,
      checkinQrDataUrl,
      qrImageUrl,
      qrImageAlt,
      followAccount,
      closeFollowDialog,
      confirmFollow
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.activity-page {
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
}

.content {
  width: 100%;
  max-width: 375px;
  height: 100vh;
  margin: 0 auto;
  position: relative;
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* 状态栏 */
.status-bar {
  width: 100vw;
  height: 17px;
  overflow: hidden;
  margin-left: calc(-50vw + 50%);
  position: relative;
}

.status-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 顶部区域 */
.header-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-top: 8px;
  margin-bottom: 5px;
  flex-shrink: 0;
}

.logo-wrapper {
  width: 72px;
  height: 44px;
  position: relative;
}

.logo-img {
  width: 100%;
  height: 67.66%;
  object-fit: contain;
}

.logo-text {
  width: 71.59%;
  height: 27.63%;
  object-fit: contain;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.title-wrapper {
  text-align: right;
}

.main-title-en {
  font-size: 26px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 800;
  color: #000000;
  line-height: 28px;
  margin-bottom: 5px;
}

.main-title-cn {
  font-size: 28px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 700;
  color: #000000;
  line-height: 28px;
}

/* 七喜小子插图 */
.fido-illustration {
  width: 110px;
  height: 60px;
  position: absolute;
  right: 10px;
  top: 95px;
}

.deco-line {
  width: 84.82%;
  height: 7.09%;
  object-fit: contain;
  position: absolute;
  bottom: 12.99%;
  left: 0.07%;
}

.fido-character {
  width: 92.78%;
  height: 99.99%;
  position: absolute;
  right: 0;
  top: 0.02%;
}

.fido-main {
  width: 51.9%;
  height: 76.68%;
  object-fit: contain;
  position: absolute;
  left: 14.61%;
  top: 0;
}

.fido-deco-1 { width: 29.55%; height: 28.09%; position: absolute; left: 45.91%; top: 71.91%; }
.fido-deco-2 { width: 3.58%; height: 4.78%; position: absolute; left: 50.59%; top: 78%; }
.fido-deco-3 { width: 5.38%; height: 19.32%; position: absolute; left: 55.31%; top: 76.11%; }
.fido-deco-4 { width: 4.78%; height: 21.57%; position: absolute; left: 60.84%; top: 75.31%; }
.fido-deco-5 { width: 5.07%; height: 18.01%; position: absolute; left: 64.33%; top: 78.08%; }
.fido-deco-6 { width: 3.79%; height: 14.9%; position: absolute; left: 69.46%; top: 80.14%; }
.fido-deco-7 { width: 27.6%; height: 29.47%; position: absolute; left: 0%; top: 69.2%; }
.fido-deco-8 { width: 3.76%; height: 5.01%; position: absolute; left: 22.33%; top: 75.59%; }
.fido-deco-9 { width: 5.64%; height: 20.27%; position: absolute; left: 15.5%; top: 73.62%; }
.fido-deco-10 { width: 5.01%; height: 22.64%; position: absolute; left: 10.32%; top: 72.79%; }
.fido-deco-11 { width: 5.32%; height: 18.91%; position: absolute; left: 6.36%; top: 75.67%; }
.fido-deco-12 { width: 3.98%; height: 15.63%; position: absolute; left: 2.32%; top: 77.84%; }
.fido-deco-13 { width: 14.52%; height: 12.36%; position: absolute; left: 55.53%; top: 51.5%; }
.fido-deco-14 { width: 18.6%; height: 15.32%; position: absolute; left: 73.79%; top: 39.79%; }
.fido-deco-15 { width: 36.96%; height: 47.45%; position: absolute; left: 63.04%; top: 23.96%; }

.fido-illustration img {
  object-fit: contain;
}

/* 活动内容标签 */
.activity-label {
  display: inline-flex;
  align-self: flex-start;
  background-color: #1580b9;
  border-radius: 6px;
  padding: 2px 7px;
  margin-bottom: 5px;
  flex-shrink: 0;
  width: auto;
}

.activity-label span {
  font-size: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 500;
  color: #ffffff;
  line-height: 18px;
}

/* 活动说明 */
.activity-description {
  margin-bottom: 8px;
  flex-shrink: 0;
}

.desc-title {
  font-size: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 700;
  color: #000000;
  line-height: 24px;
  margin-bottom: 8px;
}

.desc-subtitle {
  font-size: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 700;
  color: #000000;
  line-height: 18px;
  margin-bottom: 8px;
}

.desc-content {
  font-size: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

.desc-content .highlight {
  color: #de4c36;
  font-weight: 700;
}

/* 任务进度 */
.task-progress {
  text-align: center;
  margin-bottom: 5px;
  flex-shrink: 0;
}

.progress-text {
  font-size: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 500;
  color: #000000;
  line-height: 18px;
}

.progress-count {
  font-size: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 700;
  color: #000000;
  line-height: 18px;
}

.progress-text-cn {
  font-size: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 500;
  color: #000000;
  line-height: 18px;
}

/* 关注提示 */
.follow-hint {
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 700;
  color: #000000;
  line-height: 20px;
  margin-bottom: 8px;
  flex-shrink: 0;
}

/* 任务卡片 */
.task-cards {
  position: relative;
  margin-bottom: 10px;
  flex-shrink: 0;
}

.task-card {
  position: relative;
  width: 100%;
  height: 70px;
  margin-bottom: 8px;
}

.card-bg {
  position: absolute;
  width: 100%;
  height: 70px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #2c2a29;
  border-radius: 8px;
}

.task-number {
  position: absolute;
  width: 28px;
  height: 28px;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.number-bg {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.number-text {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 900;
  color: #000000;
  line-height: 20px;
}

.task-info {
  position: absolute;
  left: 55px;
  top: 50%;
  transform: translateY(-50%);
}

.task-name {
  font-size: 13px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 700;
  color: #ffffff;
  line-height: 18px;
}

.task-subname {
  font-size: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 700;
  color: #ffffff;
  line-height: 12px;
  margin-top: 2px;
}

.task-desc {
  font-size: 9px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  color: #ffffff;
  line-height: 16px;
  margin-top: 2px;
}

.follow-btn {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 56px;
  height: 22px;
  background-color: #1580b9;
  border: none;
  border-radius: 4px;
  font-size: 11px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 700;
  color: #ffffff;
  line-height: 22px;
  text-align: center;
  cursor: pointer;
}

.follow-btn-red {
  background-color: #de4c36;
}

.followed-badge {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 56px;
  height: 22px;
  background-color: #1580b9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.followed-badge-red {
  background-color: #de4c36;
}

.followed-badge-blue {
  background-color: #1580b9;
}

.followed-badge span {
  font-size: 11px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 700;
  color: #ffffff;
  line-height: 22px;
}

.card-divider {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 70px;
  width: 100%;
  height: 1px;
  z-index: 1;
}

.divider-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 进度条 */
.progress-bar-container {
  position: relative;
  width: 100%;
  height: 16px;
  margin: 0 auto 10px;
  flex-shrink: 0;
}

.progress-bg {
  width: 100%;
  height: 6px;
  background-color: #d9d9d9;
  border-radius: 8px;
  position: absolute;
  top: 7px;
}

.progress-fill {
  height: 100%;
  background-color: #de4c36;
  border-radius: 8px;
  transition: width 0.3s;
}

.progress-icons {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
}

.progress-start {
  width: 12px;
  height: 12px;
  position: absolute;
  left: 0;
  top: 4px;
}

.progress-end {
  width: 21px;
  height: 21px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
}

/* 品牌好友区域 */
.brand-section {
  width: 179px;
  margin: 0 auto 10px;
  text-align: center;
  flex-shrink: 0;
}

.brand-title {
  font-size: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  color: #000000;
  line-height: 18px;
  margin-bottom: 10px;
}

.brand-logos {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.brand-logo-small {
  width: 32px;
  height: 26px;
}

.brand-logo-small img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.brand-logo-large {
  width: 121px;
  height: 21px;
  position: relative;
}

.brand-logo-large img {
  width: 93.99%;
  height: 100%;
  object-fit: contain;
}

.logo-deco {
  position: absolute;
  right: 0;
  top: 19.62%;
  width: 6.03% !important;
  height: 20.98% !important;
}

/* 底部装饰 */
.bottom-decoration {
  width: 260px;
  height: 110px;
  margin: 0 auto;
  position: relative;
  flex-shrink: 0;
}

.deco-bg {
  width: 100%;
  height: 78.88%;
  object-fit: contain;
  position: absolute;
  bottom: 0;
}

.sticker-container {
  position: absolute;
  width: 60px;
  height: 61px;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
}

.sticker-img {
  width: 97.19%;
  height: 98.22%;
  object-fit: contain;
  position: absolute;
  left: 1.51%;
  top: 1.78%;
}

.sticker-main {
  width: 100%;
  height: 99.83%;
  object-fit: contain;
  position: absolute;
  left: 0;
  top: 0;
}

.sticker-text {
  width: 91.56%;
  height: 32.29%;
  object-fit: contain;
  position: absolute;
  left: 6.44%;
  top: 45.12%;
}

.sticker-icon {
  width: 15.76%;
  height: 20.2%;
  object-fit: contain;
  position: absolute;
  left: 58.45%;
  top: 14.32%;
}

.sticker-deco-1 {
  width: 5.26%;
  height: 7.92%;
  object-fit: contain;
  position: absolute;
  left: 53.11%;
  top: 41.38%;
}

.sticker-deco-2 {
  width: 3.45%;
  height: 11.67%;
  object-fit: contain;
  position: absolute;
  left: 75.86%;
  top: 26.16%;
}

.sticker-deco-3 {
  width: 3.27%;
  height: 4.16%;
  object-fit: contain;
  position: absolute;
  left: 55.07%;
  top: 40.47%;
}

/* 弹窗 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: #fff;
  border-radius: 16px;
  padding: 30px 25px;
  width: 85%;
  max-width: 320px;
  text-align: center;
}

.modal-content p {
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
}

.qr-image-wrapper {
  margin: 20px 0;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 8px;
}

.qr-image {
  width: 200px;
  height: 200px;
  display: block;
  margin: 0 auto;
}

.follow-tip {
  color: #999;
  font-size: 13px;
  margin-bottom: 25px;
}

.modal-actions {
  display: flex;
  gap: 10px;
}

.modal-btn {
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

.modal-btn.cancel {
  background: #f5f5f5;
  color: #666;
}

.modal-btn.confirm {
  background: #07c160;
  color: #fff;
}

/* 响应式适配 - 所有机型一屏显示，无滚动 */

/* 小屏幕手机 (iPhone SE, 小屏安卓) */
@media screen and (max-width: 375px) {
  .content {
    padding: 0 10px;
  }
  
  .header-section {
    padding-top: 5px;
    margin-bottom: 3px;
  }
  
  .logo-wrapper {
    width: 55px;
    height: 33px;
  }
  
  .main-title-en {
    font-size: 18px;
    line-height: 20px;
  }
  
  .main-title-cn {
    font-size: 20px;
    line-height: 20px;
  }
  
  .fido-illustration {
    width: 85px;
    height: 46px;
    top: 50px;
    right: 5px;
  }
  
  .activity-label {
    margin-bottom: 3px;
  }
  
  .activity-description {
    margin-bottom: 5px;
  }
  
  .desc-title {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 3px;
  }
  
  .desc-subtitle {
    font-size: 11px;
    margin-bottom: 3px;
  }
  
  .desc-content {
    font-size: 11px;
    line-height: 16px;
  }
  
  .task-progress {
    margin-bottom: 3px;
  }
  
  .follow-hint {
    font-size: 13px;
    line-height: 18px;
    margin-bottom: 5px;
  }
  
  .task-cards {
    margin-bottom: 5px;
  }
  
  .task-card {
    height: 60px;
    margin-bottom: 5px;
  }
  
  .card-bg {
    height: 60px;
  }
  
  .task-number {
    width: 24px;
    height: 24px;
    left: 12px;
  }
  
  .number-text {
    font-size: 18px;
    line-height: 18px;
  }
  
  .task-info {
    left: 45px;
  }
  
  .task-name {
    font-size: 12px;
    line-height: 16px;
  }
  
  .task-subname {
    font-size: 11px;
    line-height: 11px;
  }
  
  .task-desc {
    font-size: 8px;
    line-height: 14px;
    margin-top: 1px;
  }
  
  .follow-btn,
  .followed-badge {
    width: 50px;
    height: 20px;
    right: 12px;
  }
  
  .follow-btn {
    font-size: 10px;
    line-height: 20px;
  }
  
  .followed-badge span {
    font-size: 10px;
    line-height: 20px;
  }
  
  .card-divider {
    top: 60px;
  }
  
  .progress-bar-container {
    height: 14px;
    margin-bottom: 5px;
  }
  
  .brand-section {
    margin-bottom: 5px;
  }
  
  .bottom-decoration {
    width: 220px;
    height: 95px;
  }
  
  .sticker-container {
    width: 50px;
    height: 51px;
  }
}

/* 中等屏幕手机 (iPhone 12/13/14, 安卓标准屏) */
@media screen and (min-width: 376px) and (max-width: 414px) {
  .content {
    padding: 0 12px;
  }
  
  .header-section {
    padding-top: 6px;
  }
  
  .logo-wrapper {
    width: 62px;
    height: 38px;
  }
  
  .main-title-en {
    font-size: 22px;
    line-height: 24px;
  }
  
  .main-title-cn {
    font-size: 24px;
    line-height: 24px;
  }
  
  .fido-illustration {
    width: 110px;
    height: 60px;
    top: 93px;
  }
  
  .activity-description {
    margin-bottom: 6px;
  }
  
  .desc-title {
    font-size: 18px;
  }
  
  .task-card {
    height: 65px;
  }
  
  .card-bg {
    height: 65px;
  }
  
  .task-number {
    width: 26px;
    height: 26px;
  }
  
  .number-text {
    font-size: 19px;
  }
  
  .task-desc {
    font-size: 8.5px;
  }
  
  .card-divider {
    top: 65px;
  }
  
  .bottom-decoration {
    width: 240px;
    height: 102px;
  }
  
  .sticker-container {
    width: 55px;
    height: 56px;
  }
}

/* 大屏幕手机 (iPhone 14 Pro Max, 大屏安卓) */
@media screen and (min-width: 415px) and (max-width: 430px) {
  .content {
    padding: 0 15px;
  }
  
  .header-section {
    padding-top: 8px;
  }
  
  .logo-wrapper {
    width: 68px;
    height: 42px;
  }
  
  .main-title-en {
    font-size: 24px;
    line-height: 26px;
  }
  
  .main-title-cn {
    font-size: 26px;
    line-height: 26px;
  }
  
  .fido-illustration {
    width: 125px;
    height: 68px;
    top: 98px;
  }
  
  .desc-title {
    font-size: 20px;
  }
  
  .task-card {
    height: 70px;
  }
  
  .card-bg {
    height: 70px;
  }
  
  .task-number {
    width: 28px;
    height: 28px;
  }
  
  .number-text {
    font-size: 20px;
  }
  
  .card-divider {
    top: 70px;
  }
  
  .bottom-decoration {
    width: 260px;
    height: 110px;
  }
}

/* 超大屏幕手机和平板 */
@media screen and (min-width: 431px) {
  .content {
    max-width: 430px;
    padding: 0 18px;
  }
  
  .header-section {
    padding-top: 10px;
    margin-bottom: 8px;
  }
  
  .logo-wrapper {
    width: 72px;
    height: 44px;
  }
  
  .main-title-en {
    font-size: 26px;
    line-height: 28px;
  }
  
  .main-title-cn {
    font-size: 28px;
    line-height: 28px;
  }
  
  .fido-illustration {
    width: 135px;
    height: 73px;
    top: 102px;
  }
  
  .activity-description {
    margin-bottom: 10px;
  }
  
  .desc-title {
    font-size: 22px;
    line-height: 26px;
  }
  
  .task-card {
    height: 75px;
    margin-bottom: 8px;
  }
  
  .card-bg {
    height: 75px;
  }
  
  .task-number {
    width: 30px;
    height: 30px;
    left: 18px;
  }
  
  .number-text {
    font-size: 22px;
  }
  
  .task-info {
    left: 58px;
  }
  
  .follow-btn,
  .followed-badge {
    width: 58px;
    height: 24px;
    right: 18px;
  }
  
  .card-divider {
    top: 75px;
  }
  
  .bottom-decoration {
    width: 280px;
    height: 120px;
  }
  
  .sticker-container {
    width: 65px;
    height: 66px;
  }
}

/* 横屏适配 */
@media screen and (max-height: 600px) and (orientation: landscape) {
  .content {
    padding: 0 10px;
  }
  
  .header-section {
    padding-top: 3px;
    margin-bottom: 2px;
  }
  
  .logo-wrapper {
    width: 50px;
    height: 30px;
  }
  
  .main-title-en {
    font-size: 16px;
    line-height: 18px;
  }
  
  .main-title-cn {
    font-size: 18px;
    line-height: 18px;
  }
  
  .fido-illustration {
    width: 85px;
    height: 46px;
    top: 80px;
  }
  
  .activity-label {
    margin-bottom: 2px;
  }
  
  .activity-description {
    margin-bottom: 4px;
  }
  
  .desc-title {
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 2px;
  }
  
  .task-progress {
    margin-bottom: 2px;
  }
  
  .follow-hint {
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 4px;
  }
  
  .task-cards {
    margin-bottom: 4px;
  }
  
  .task-card {
    height: 55px;
    margin-bottom: 4px;
  }
  
  .card-bg {
    height: 55px;
  }
  
  .task-number {
    width: 22px;
    height: 22px;
    left: 10px;
  }
  
  .number-text {
    font-size: 16px;
  }
  
  .task-info {
    left: 40px;
  }
  
  .task-name {
    font-size: 11px;
    line-height: 14px;
  }
  
  .task-desc {
    font-size: 7px;
    line-height: 12px;
  }
  
  .follow-btn,
  .followed-badge {
    width: 48px;
    height: 18px;
    right: 10px;
  }
  
  .follow-btn {
    font-size: 9px;
    line-height: 18px;
  }
  
  .card-divider {
    top: 55px;
  }
  
  .progress-bar-container {
    height: 12px;
    margin-bottom: 8px;
  }
  
  .brand-section {
    margin-bottom: 8px;
  }
  
  .bottom-decoration {
    width: 200px;
    height: 85px;
  }
  
  .sticker-container {
    width: 45px;
    height: 46px;
  }
}
</style>
